import { Empty, Skeleton } from 'antd';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import MultiVideoPlayer from './MultiVideoPlayer';

const DynamicQuestionDetails = forwardRef((props, ref) => {
  const { candidatessementAnswer, isLoading, setPlayerControls } = props;
  const videoRefs = useRef({});
  useImperativeHandle(ref, () => ({
    getValue: () => {
      return videoRefs;
    },
  }));

  const handlePlayerReady = (controls) => {
    setPlayerControls(controls);
  };


  console.log(candidatessementAnswer, 'candidatessementAnswer');
  return (
    <div className="tab:flex block gap-6 w-full mt-6">
      <div className="tab:w-[60%] w-full h-[calc(100vh-20rem)] overflow-auto customScrollBar">
        {isLoading
          ? Array.from({ length: 5 }).map((_, index) => (
              <div className="bg-white rounded-md shadow-[0_4px_4px_0_#F1F2F2] p-7 mb-5">
                <Skeleton
                  active
                  paragraph={{ rows: 2 }}
                  className="mt-4"
                />
              </div>
            ))
          : candidatessementAnswer?.conversation?.map((qstn) => (
              <div className="bg-white rounded-md shadow-[0_4px_4px_0_#F1F2F2] p-7 mb-5">
                <h3 className="text-[#000] font-poppins text-sm font-medium capitalize">
                  {qstn?.question_text}
                </h3>
                <p className="leading-6 text-[#525252] font-poppins text-sm capitalize mt-3">
                  {qstn?.answer}
                </p>

                {/* <div className="mt-6">
                  <DynamicProgress value={qstn?.answer_level || 0} />
                </div> */}
              </div>
            ))}
      </div>
      <div className="tab:w-[40%] w-full">
        {/* 2xl:h-[350px] 2xl:w-[500px] xl:w-[390px] xl:h-[300px] lg:w-[350px] lg:h-[230px] mid-s:w-[310px] mid-s:h-[220px] w-[270px] */}
        {/* h-[390px] */}
        <div className="bg-white border rounded-md w-full">
          <h3 className="text-[#1F1F1F] font-poppins text-sm font-medium capitalize p-6">
            answered Video
          </h3>
          <MultiVideoPlayer videos={candidatessementAnswer?.answer_video_urls} onPlayerReady={handlePlayerReady} />
          {/* {isLoading ? (
            <Skeleton active paragraph={{ rows: 6 }} className="mt-4 p-2" />
          ) : candidatessementAnswer?.answer_video ? (
            <video
              className="w-full h-full"
              controls
              controlsList="nodownload"
              onContextMenu={(e) => e.preventDefault()}
              ref={videoRefs}
            >
              <source
                src={candidatessementAnswer?.answer_video}
                type="video/mp4"
              />
              <source
                src={candidatessementAnswer?.answer_video}
                type="video/ogg"
              />
              Your browser does not support the video tag.
            </video>
          ) : (
            <Empty
              description={
                <p className="text-xs">
                  <span className="font-semibold">no video available</span>
                </p>
              }
            />
          )} */}
        </div>
      </div>
    </div>
  );
});
export default DynamicQuestionDetails;
